import { SignUpHeader } from '../components/SignUpHeader';
import { SignUpSuccess } from '../components/SignUpSuccess';

export default function SignUpSuccessPage() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <SignUpHeader />
      <main className="flex-1 flex items-center justify-center py-12 px-4">
        <SignUpSuccess />
      </main>
    </div>
  );
}
